import {request} from "./client";

export const getMyLeads = () => request("/broker/leads");

/** Only enquiries and brochure requests ("lead-<id>") have a status the broker sets; tours have their own. */
export const setLeadStatus = (leadId, status) =>
    request(`/broker/leads/${String(leadId).replace(/^lead-/, "")}`, {method: "PATCH", body: {status}});

/** Public: a buyer's enquiry from the property page. */
export const sendEnquiry = (propertyId, enquiry) =>
    request(`/properties/${propertyId}/enquiry`, {method: "POST", body: enquiry, auth: null});
